"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GreetingCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const UserContext_1 = require("../contexts/UserContext");
const cancelable_promise_1 = require("cancelable-promise");
const react_i18next_1 = require("react-i18next");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        container: {
            borderWidth: 0,
            borderRadius: 4
        },
        text: {
            color: THEME.Text,
            fontWeight: '300',
            fontSize: size != 'sm' ? 20 : 16,
            textAlign: 'center',
            alignSelf: 'center',
            padding: 8
        }
    });
};
function GreetingCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [greeting, setGreeting] = react_1.default.useState("");
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => MyProfile_1.default.getPersonalInfo(token))).then(async (data) => {
            const hours = new Date().getHours();
            const hello = hours < 12 ? t("common:text.greetMorning") : (hours < 18 ? t("common:text.greetAfternoon") : t("common:text.greetEvening"));
            setGreeting(`${hello}, ${data.firstName}!`);
            if (data.birthDate || data.hireDate) {
                const birthDate = new Date(data.birthDate);
                const hireDate = new Date(data.hireDate);
                const today = new Date();
                if (birthDate.getUTCMonth() === today.getMonth() && birthDate.getUTCDate() === today.getDate()) {
                    const lastBirthdayShown = await async_storage_1.default.getItem('birthday');
                    if (lastBirthdayShown !== today.getFullYear().toString()) {
                        await async_storage_1.default.setItem('birthday', today.getFullYear().toString());
                        props.navigation.navigate('Celebrate', { type: 'birthday', name: data.firstName });
                    }
                }
                else if (hireDate.getUTCMonth() === today.getMonth() && hireDate.getUTCDate() === today.getDate()) {
                    const lastAnniversaryShown = await async_storage_1.default.getItem('anniversary');
                    if (lastAnniversaryShown !== today.getFullYear().toString()) {
                        await async_storage_1.default.setItem('anniversary', today.getFullYear().toString());
                        props.navigation.navigate('Celebrate', { type: 'anniversary', name: data.firstName });
                    }
                }
            }
        }).catch((e) => {
            setGreeting(null);
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, [refresh]);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.container, { overflow: 'hidden' }], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { maxHeight: 300, width: '100%' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != "sm" ? Theme_1.IMAGES.HomeBackgroundWeb : Theme_1.IMAGES.HomeBackground, style: { width: '100%', height: 'auto', aspectRatio: size != "sm" ? 11.2 : 5.6, borderTopLeftRadius: 4, borderTopRightRadius: 4 } }) }), (0, jsx_runtime_1.jsx)(FadeInView_1.default, { style: { backgroundColor: size != "sm" ? THEME.PrimaryLight : THEME.PrimaryLightest, marginTop: -1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.text, children: greeting }) })] }));
}
